<h2>Detail</h2>

<div class="breadcrumb-container">
  @for (item of breadcrumb(); track item; let i = $index) {
    <span class="breadcrumb">
      @if (i !== 0) {
        <cue-icon [icon]="ICONS.cueArrowRight" />
      }
      <span class="part">{{ item.name }}</span>
    </span>
  }
</div>

<cue-working-hours [workingHourInfo]="resource()" />

@if (configService.value.infoSettings.descriptionVisible) {
  <p
    class="descriptionText room-description"
    [innerHTML]="resource().description | localizedString | cueCustomUnsafeSanitize"
  ></p>
}

<div class="grid grid-cols-2 gap-2">
  <span class="key">{{ translation.leftMenu.type | transloco }}</span>
  <span class="value">{{ resource().name }}</span>

  @if (configService.getResourceTypeFromId(resource().resourceTypeId).capacityVisible) {
    <span class="key">{{ translation.resourceDetail.capacity | transloco }}</span>
    <span class="value">{{ resource().capacity }}</span>
  }

  @for (
    simpleFilter of configService.getSimpleFiltersByResourceTypeId(resource(), translocoService);
    track simpleFilter
  ) {
    @if (simpleFilter.value !== undefined && simpleFilter.value !== null && simpleFilter.value !== '') {
      <span class="key">{{ simpleFilter.name | localizedString }}</span>
      @if (simpleFilter.value === true) {
        <cue-icon [icon]="ICONS.cueCheck" class="correct" />
      }

      @if (simpleFilter.value === false) {
        <cue-icon [icon]="ICONS.cueClose" class="incorrect" />
      }

      @if (simpleFilter.value !== true && simpleFilter.value !== false) {
        <div [innerHTML]="simpleFilter.value | localizedString | cueCustomUnsafeSanitize"></div>
      }
    }
  }
  @for (enumerableFilter of configService.getEnumerableFiltersByResourceTypeId(resource()); track enumerableFilter) {
    @if (enumerableFilter.visible) {
      <ul class="room-properties">
        <div class="item-label">
          {{ enumerableFilter.name | localizedString }}
        </div>
        @for (value of enumerableFilter.value; track value) {
          <li>
            <div class="img-wrapper">
              <img [class.!object-cover]="value.imagePreferCover" [src]="value.imageUrl | imageWidth: 50" />
            </div>
            <span class="descriptionText">
              {{ value.title | localizedString }}
            </span>
          </li>
        }
      </ul>
    }
  }
</div>

@if (serverDetail()?.qrCodes && serverDetail()?.qrCodes.length > 0) {
  <div class="pois-wrapper">
    <h3 class="title">{{ translation.navigation.pois | transloco }}</h3>
    @for (qrCode of serverDetail()?.qrCodes; track qrCode.qrCodeId) {
      <cue-poi
        [poi]="qrCode"
        link="false"
        class="cursor-pointer"
        [routerLink]="[]"
        [queryParams]="{ multiview: qrCode.qrCodeId }"
        queryParamsHandling="merge"
        [selected]="qrCode.qrCodeId === this.qrCodeId()"
      />
    }
  </div>
}

<div class="delimiter"></div>
<cue-file-gallery [files]="resource().files" />
